import {SODeleteToken} from '../../core/token/so-delete-token';
import {DeleteEntityProtocol} from 'lionheartland';
import {BaseDelete} from 'lionheartland';


export class RADeleteToken extends BaseDelete implements DeleteEntityProtocol {
  deleteClass = SODeleteToken;
}